import { z } from "zod";

export const AudioSettingsSliceSchema = z.object({
    slotMachineMusicEnabled: z.boolean(),
    careerMusicEnabled: z.boolean(),
    soundEffectsEnabled: z.boolean(),
});

export type AudioSettingsSlice = z.infer<typeof AudioSettingsSliceSchema>;

export const DEFAULT_AUDIO_SETTINGS: AudioSettingsSlice =
    AudioSettingsSliceSchema.parse({
        slotMachineMusicEnabled: true,
        careerMusicEnabled: true,
        soundEffectsEnabled: true,
    });
